// -------------------------------------------- IMPORT FILES START --------------------------------------------------------------
// ## Import Files
import $api from "../../Api";
import ResponseChecker from "../../Middlewares/ResponseChecker";
import { defaultMessages } from "../../enums/responseMessages.js";

import Endpoints from "../../Endpoints";

// ## Customer Get
/**
 *
 * @param {{params: object, query: {maxLongitude: number, minLongitude: number, maxLatitude: string, minLatitude: string, userType: CustomerType, page: number, limit: number, lastPlanFilter: PlanFilterType, isYearCustomer: boolean, searchKey: string, regionId: string, employeeId: string}}} option
 *
 * @returns
 */
export const GetAll = async (option) => {
  const response = await $api.get(
    Endpoints.Customer.GetAll({
      query: {
        ...option.query,
        parasutAccountId: option.query.companyId,
      },
      params: option.params,
    })
  );
  const checker = await ResponseChecker(defaultMessages, response);

  return checker;
};

// ## Customer Create
/**
 *
 * @param { parasutAccountId?: string. } } form
 * @param {{params: { id: string }, query: object}} option
 
 * @returns
 */
export const Create = async (form) => {
  let data = new FormData();

  data.append(`fullName`, form.fullName);
  data.append(`companyName`, form.companyName);
  data.append(
    `phoneNo`,
    form.phoneNo.length === 10
      ? `+90${form.phoneNo}`
      : form.phoneNo.length === 11
      ? `+9${form.phoneNo}`
      : form.phoneNo
  );
  data.append(`taxNo`, form.taxNo || "");
  data.append(`taxOffice`, form.taxOffice || "");
  data.append(`email`, form.email || "");
  data.append(`faxNo`, form.faxNo || "");
  data.append(`address.province`, form.address.province || "");
  data.append(`address.district`, form.address.district || "");
  data.append(`address.address`, form.address.address || "");
  data.append(`address.latitude`, form.address.latitude || "");
  data.append(`address.longitude`, form.address.longitude || "");
  data.append(`address.buildingNo`, form.address.buildingNo || "");
  data.append(`address.floorNo`, form.address.floorNo || "");
  data.append(`address.apartmentNo`, form.address.apartmentNo || "");
  data.append(`address.country`, form.address.country || "");
  data.append(`address.postalCode`, form.address.postalCode || "");
  data.append(`shippingAddress.province`, form.shippingAddress.province || "");
  data.append(`shippingAddress.district`, form.shippingAddress.district || "");
  data.append(`shippingAddress.address`, form.shippingAddress.address || "");
  data.append(`shippingAddress.latitude`, form.shippingAddress.latitude || "");
  data.append(
    `shippingAddress.longitude`,
    form.shippingAddress.longitude || ""
  );
  data.append(
    `shippingAddress.buildingNo`,
    form.shippingAddress.buildingNo || ""
  );
  data.append(`shippingAddress.floorNo`, form.shippingAddress.floorNo || "");
  data.append(
    `shippingAddress.apartmentNo`,
    form.shippingAddress.apartmentNo || ""
  );
  data.append(`shippingAddress.country`, form.shippingAddress.country || "");
  data.append(
    `shippingAddress.postalCode`,
    form.shippingAddress.postalCode || ""
  );
  data.append(`workStartTime`, form.workStartTime || "");
  data.append(`workFinishTime`, form.workFinishTime || "");
  // data.append(`employeeId`, form.employeeInfo.id || '')
  data.append(`image`, form.image || "");
  data.append(`isAbroad`, form.isAbroad);
  data.append(`regionId`, form.regionId || "");
  data.append(`shortName`, form.shortName || "");
  const response = await $api.post(Endpoints.Customer.Create(), data);
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## Customer Update
/**
 *
 * @param { parasutAccountId?: string. } } form
 * @param {{params: { id: string }, query: object}} option
 
 * @returns
 */
export const Update = async (form, option) => {
  const data = new FormData();

  data.append(`fullName`, form.fullName);
  data.append(`companyName`, form.companyName);
  data.append(
    `phoneNo`,
    form.phoneNo.length === 10
      ? `+90${form.phoneNo}`
      : form.phoneNo.length === 11
      ? `+9${form.phoneNo}`
      : form.phoneNo
  );
  data.append(`taxNo`, form.taxNo);
  data.append(`taxOffice`, form.taxOffice);
  data.append(`email`, form.email || "");
  data.append(`faxNo`, form.faxNo || "");
  data.append(`address.province`, form.address.province || "");
  data.append(`address.district`, form.address.district || "");
  data.append(`address.address`, form.address.address || "");
  data.append(`address.latitude`, form.address.latitude || "");
  data.append(`address.longitude`, form.address.longitude || "");
  data.append(`address.buildingNo`, form.address.buildingNo || "");
  data.append(`address.floorNo`, form.address.floorNo || "");
  data.append(`address.apartmentNo`, form.address.apartmentNo || "");
  data.append(`address.country`, form.address.country || "");
  data.append(`address.postalCode`, form.address.postalCode || "");
  data.append(`shippingAddress.province`, form.shippingAddress.province || "");
  data.append(`shippingAddress.district`, form.shippingAddress.district || "");
  data.append(`shippingAddress.address`, form.shippingAddress.address || "");
  data.append(`shippingAddress.latitude`, form.shippingAddress.latitude || "");
  data.append(
    `shippingAddress.longitude`,
    form.shippingAddress.longitude || ""
  );
  data.append(
    `shippingAddress.buildingNo`,
    form.shippingAddress.buildingNo || ""
  );
  data.append(`shippingAddress.floorNo`, form.shippingAddress.floorNo || "");
  data.append(
    `shippingAddress.apartmentNo`,
    form.shippingAddress.apartmentNo || ""
  );
  data.append(`shippingAddress.country`, form.shippingAddress.country || "");
  data.append(
    `shippingAddress.postalCode`,
    form.shippingAddress.postalCode || ""
  );
  data.append(`workStartTime`, form.workStartTime || "");
  data.append(`workFinishTime`, form.workFinishTime || "");
  // data.append(`employeeId`, form.employeeInfo.id)
  data.append(`image`, form.image || "");
  data.append(`isAbroad`, form.isAbroad);
  data.append(`regionId`, form.regionId || "");
  if (form.isActive === true || form.isActive === false)
    data.append(`isActive`, form.isActive);

  data.append(`shortName`, form.shortName || "");
  if (form.yearTime) data.append("yearTime", form.yearTime);
  else {
    data.append("yearTime", "");
    data.append("yearTimeStart", "");
    data.append("yearTimePrice", "");
  }
  if (form.yearTimeStart) data.append("yearTimeStart", form.yearTimeStart);
  if (form.yearTimePrice) data.append("yearTimePrice", form.yearTimePrice);
  if (form.parasutAccountId) {
    data.append("parasutAccountId", form.parasutAccountId);
    data.append(`transferParasut`, true);
  } else data.append(`transferParasut`, false);

  const response = await $api.put(Endpoints.Customer.Update(option), data);
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};
// ## Customer Update
/**
 *
 * @param { parasutAccountId?: string. } } form
 * @param {{params: { id: string }, query: object}} option
 
 * @returns
 */
export const Transfer = async (form, option) => {
  // FormData yerine düz bir obje oluşturuyoruz
  const data = {
    fullName: form.fullName,
    companyName: form.companyName,
    phoneNo:
      form.phoneNo.length === 10
        ? `+90${form.phoneNo}`
        : form.phoneNo.length === 11
        ? `+9${form.phoneNo}`
        : form.phoneNo,
    taxNo: form.taxNo,
    taxOffice: form.taxOffice,
    email: form.email || "",
    faxNo: form.faxNo || "",
    address: {
      province: form.address.province || "",
      district: form.address.district || "",
      address: form.address.address || "",
      latitude: form.address.latitude || "",
      longitude: form.address.longitude || "",
      buildingNo: form.address.buildingNo || "",
      floorNo: form.address.floorNo || "",
      apartmentNo: form.address.apartmentNo || "",
      country: form.address.country || "",
      postalCode: form.address.postalCode || "",
    },
    shippingAddress: {
      province: form.shippingAddress.province || "",
      district: form.shippingAddress.district || "",
      address: form.shippingAddress.address || "",
      latitude: form.shippingAddress.latitude || "",
      longitude: form.shippingAddress.longitude || "",
      buildingNo: form.shippingAddress.buildingNo || "",
      floorNo: form.shippingAddress.floorNo || "",
      apartmentNo: form.shippingAddress.apartmentNo || "",
      country: form.shippingAddress.country || "",
      postalCode: form.shippingAddress.postalCode || "",
    },
    workStartTime: form.workStartTime || 0,
    workFinishTime: form.workFinishTime || 0,
    // employeeId: form.employeeInfo.id, // Gerekirse açabilirsiniz
    image: form.image || "",
    isAbroad: form.isAbroad,
    regionId: form.regionId || "",
    shortName: form.shortName || "",
    isActive: form.isActive,
    transferParasut: form.parasutAccountId !== "" ? true : false,
  };

  if (form.yearTime) data.yearTime = form.yearTime;
  if (form.parasutAccountId !== "") {
    data.parasutAccountId = form.parasutAccountId;
  }

  const response = await $api.put(Endpoints.Customer.Update(option), data);
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## Customer Update Parasut Info
/**
 *
 * @param {Array<{parasutAccountId: string, parasutId: string}>} form
 * @param {{params: { id: string }, query: object}} option
 *
 * @returns
 */
export const UpdateCustomerParasutInfo = async (form, option) => {
  const response = await $api.put(
    Endpoints.Customer.UpdateCustomerParasutInfo(option),
    form
  );
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

export default {
  GetAll,
  Transfer,
  Update,
  Create,
  UpdateCustomerParasutInfo,
};
